module.exports = __webpack_public_path__ + "static/media/lamina14act.152198d5.png";